import { createAction, props } from '@ngrx/store'
import { User, UserWithPassword } from '../components/shared/model/user.model'

export const loadUsers = createAction(
  '[Users] Load Users',
  props<{ pageIndex: number; pageSize: number }>()
)

export const loadUsersSuccess = createAction(
  '[Users] Load Users Success',
  props<{ users: User[]; totalCount: number }>()
)

export const loadUsersFailure = createAction(
  '[Users] Load Users Failure',
  props<{ error: string }>()
)

export const createUser = createAction(
  '[User] Create User',
  props<{ user: Partial<UserWithPassword> }>()
)

export const createUserSuccess = createAction(
  '[Users] Create User Success',
  props<{ user: User }>()
)

export const createUserFailure = createAction(
  '[Users] Create User Failure',
  props<{ error: string }>()
)

export const updateUser = createAction(
  '[Users] Update User',
  props<{ id: number; user: Partial<UserWithPassword> }>()
)

export const updateUserSuccess = createAction(
  '[Users] Update User Success',
  props<{ id: number; user: Partial<UserWithPassword> }>()
)

export const updateUserFailure = createAction(
  '[Users] Update User Failure',
  props<{ error: string }>()
)

export const deleteUser = createAction(
  '[Users] Delete User',
  props<{ id: number }>()
)

export const deleteUserSuccess = createAction(
  '[Users] Delete User Success',
  props<{ id: number }>()
)

export const deleteUserFailure = createAction(
  '[Users] Delete User Failure',
  props<{ error: string }>()
)

export const loadCurrentUser = createAction('[Auth] Load Current User')

export const loadCurrentUserSuccess = createAction(
  '[Auth] Load Current User Success',
  props<{ user: User }>()
)

export const loadCurrentUserFailure = createAction(
  '[Auth] Load Current User Failure',
  props<{ error: string }>()
)

export const clearCurrentUser = createAction('[Auth] Clear Current User')
